export default "__VITE_ASSET__d3c3b26c__"